<template lang="pug">
  div.swiper-container(ref="container")
    div.swiper-wrapper
      div.swiper-slide(v-for="(item, $index) in list")
        img.slide-image(:src="item.img", alt="alt" title="title")
    div.swiper-pagination(ref="pagenation")
</template>
<script>

import Swiper from 'swiper'
export default {
  name: 'SwiperCarousel',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      swiper: null,
      options: {
        pagination: {
          el: '.swiper-pagination',
          bulletActiveClass: 'bullet-active'
        },
        autoplay: true,
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: true,
        direction: 'horizontal', // 垂直切换选项
        loop: true // 循环模式选项
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.swiper = new Swiper(this.$refs.container, this.options)
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~swiper/dist/css/swiper.min.css";
.swiper-container {
  padding-bottom: 3rem;
}
.swiper-slide {
  width: 100%;
    img {
      max-height: 90vh;
      width: auto;
      max-width: 90vw;
    }
}
.slide-image {
  max-width: 100%;
}

@media only screen and (min-width: 768px) {
  .swiper-slide {
    width: auto;
  }
}

</style>

<style lang="scss">
.bullet-active {
  background: #1a1a1a;
  opacity: 1;
}
</style>
